export default "__VITE_ASSET__a923291d__"